import React from 'react';
import Index from './Index';
import JournalEntriesView from '../components/views/JournalEntriesView';
import { modules } from '../config/const';

function JournalEntriesPage() {
  return <Index content={JournalEntriesView} module={modules.JournalEntries} />;
}

export default JournalEntriesPage;
